import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const CreateOptionsModal = ({ isOpen, onClose, onCreateInvoice, onCreateAgreement, onCreateEmail }) => {
  const options = [
    {
      label: 'Invoice',
      description: 'Send a bill to your client',
      action: () => {
        onCreateInvoice?.();
        onClose();
      },
    },
    {
      label: 'Contract',
      description: 'Create an agreement for signing',
      action: () => {
        onCreateAgreement?.();
        onClose();
      },
    },
    {
      label: 'Email',
      description: 'Compose and send a message',
      action: () => {
        onCreateEmail?.();
        onClose();
      },
    },
  ];

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.15 }}
          className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center p-4 z-[90]"
          onClick={onClose}
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            transition={{ duration: 0.2 }}
            onClick={(e) => e.stopPropagation()}
            className="bg-white dark:bg-[#111111] rounded-3xl shadow-2xl w-full max-w-md overflow-hidden relative"
          >
            {/* Close button */}
            <button
              onClick={onClose}
              className="absolute top-5 right-5 w-8 h-8 flex items-center justify-center rounded-full text-gray-400 hover:text-gray-600 hover:bg-gray-100 dark:hover:bg-white/10 dark:hover:text-gray-300 transition-all"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>

            <div className="p-8 pb-4">
              <h2 className="text-2xl font-light text-gray-900 dark:text-white mb-1">Create</h2>
              <p className="text-sm text-gray-400">What would you like to make?</p>
            </div>

            <div className="px-6 pb-8 space-y-3">
              {options.map((option, i) => (
                <motion.button
                  key={option.label}
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: i * 0.05 }}
                  onClick={option.action}
                  className="w-full p-5 rounded-2xl text-left bg-gray-50 dark:bg-white/5 hover:bg-gray-100 dark:hover:bg-white/10 transition-all"
                >
                  <p className="text-lg font-medium text-gray-900 dark:text-white mb-1">
                    {option.label}
                  </p>
                  <p className="text-sm text-gray-500 dark:text-gray-400">
                    {option.description}
                  </p>
                </motion.button>
              ))}
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CreateOptionsModal;
